// extracted by mini-css-extract-plugin
export default {"compare-plans-section":"ComparePlansSection_compare-plans-section__9lRrP","note":"ComparePlansSection_note__IC6Nx"};